// authReducer.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patients: [], // Stores all practices
};

export const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setPatients: (state, action) => {
      state.patients = action.payload;
    },
  },
});

export const { setPatients } = patientSlice.actions;
export default patientSlice.reducer;
